export const SET_STEPS = 'setSteps';
export const SET_STEPS_MUTATION = 'setStepsMutation';

export const SET_ALLOW_ACTIONS_NEXT = 'setAllowActionsNext';
export const SET_ALLOW_ACTIONS_NEXT_MUTATION = 'setAllowActionsNextMutation';

export const SET_ALLOW_ACTIONS_PREVIOUS = 'setAllowActionsPrevious';
export const SET_ALLOW_ACTIONS_PREVIOUS_MUTATION = 'setAllowActionsPreviousMutation';

export const SET_OPEN_MODAL = 'setOpenModal';
export const SET_OPEN_MODAL_MUTATION = 'setOpenModalMutation';

export const SET_ONBOARDING_DATA = 'setFlow';
export const SET_ONBOARDING_DATA_MUTATION = 'setFlowMutation';

// BASE ON UI
// THIS ACTION WILL TRUE WHEN USER COMPLETED 2 TUTORIALS IN GUI
export const SET_FINISHED = 'setFinished';
export const SET_FINISHED_MUTATION = 'setFinishedMutation';

// BASE ON API
// THIS ACTION WILL TRUE WHEN API RETURN TRUE
export const SET_COMPLETED_ALL = 'setCompletedAll';
export const SET_COMPLETED_ALL_MUTATION = 'setCompletedAllMutation';

export const SET_SKIP = 'setSkip';
export const SET_SKIP_MUTATION = 'setSkipMutation';

export const HOLDING_STEP = "holdingStep"; 
export const HOLDING_STEP_MUTATION = "holdingStepMutation"; 

export const RESET_ONBOARDING = 'resetOnboarding';
export const RESET_ONBOARDING_MUTATION = 'resetOnboardingMutation';

export const HAS_ONBOARDING = 'hasOnboarding';
export const HAS_ONBOARDING_MUTATION = 'hasOnboardingMutation';

export const SET_ONBOARDING_PER_PAGE = 'setOnboardingPerPage';
export const SET_ONBOARDING_PER_PAGE_MUTATION = 'setOnboardingPerPageMutation';

export default {
    namespace: 'userOnboardingModule',

    state: () => ({
        onboarding: {
            flow: null,
            tutorials: {},
            status: null,
        },

        allowActions: {
            next: true,
            previous: true,
        },

        steps: [],

        hasOnboarding: false,
        isFinished: false,
        isCompletedAll: false,
        isSkip: false,
        isHolding: false, // client holding, not server response
        onboardingPerPage: {
            isOnboardingPerPage: true,
            pageName: ''
        }
    }),

    actions: {
        [SET_STEPS](ctx, payload = []) {
            ctx.commit(SET_STEPS_MUTATION, payload);
        },

        [SET_ALLOW_ACTIONS_NEXT](ctx, payload = true) {
            ctx.commit(SET_ALLOW_ACTIONS_NEXT_MUTATION, payload);
        },

        [SET_ALLOW_ACTIONS_PREVIOUS](ctx, payload = true) {
            ctx.commit(SET_ALLOW_ACTIONS_PREVIOUS_MUTATION, payload);
        },

        [SET_ONBOARDING_DATA](ctx, data = '') {
            ctx.commit(SET_ONBOARDING_DATA_MUTATION, data);
        },

        [SET_FINISHED](ctx, isFinish = true) {
            ctx.commit(SET_FINISHED_MUTATION, isFinish);
        },
        
        [SET_COMPLETED_ALL](ctx, status = true) {
            ctx.commit(SET_COMPLETED_ALL_MUTATION, status);
        },
        
        [SET_SKIP](ctx, status = true) {
            ctx.commit(SET_SKIP_MUTATION, status);
        },

        [RESET_ONBOARDING](ctx) {
            ctx.commit(RESET_ONBOARDING_MUTATION);
        },

        [HAS_ONBOARDING](ctx, has = true) {
            ctx.commit(HAS_ONBOARDING_MUTATION, has);
        },

        [HOLDING_STEP](ctx, holding = true) {
            ctx.commit(HOLDING_STEP_MUTATION, holding);
        },

        [SET_ONBOARDING_PER_PAGE](ctx, data) {
            ctx.commit(SET_ONBOARDING_PER_PAGE_MUTATION, data);
        },
    },

    mutations: {
        [SET_STEPS_MUTATION](state, payload = []) {
            return (state.steps = payload);
        },

        [SET_ALLOW_ACTIONS_NEXT_MUTATION](state, payload = true) {
            return (state.allowActions.next = payload);
        },

        [SET_ALLOW_ACTIONS_PREVIOUS_MUTATION](state, payload = true) {
            return (state.allowActions.previous = payload);
        },

        [SET_ONBOARDING_DATA_MUTATION](state, data) {
            return (state.onboarding = data);
        },

        [SET_FINISHED_MUTATION](state, isFinish = true) {
            return (state.isFinished = isFinish);
        },
        
        [SET_COMPLETED_ALL_MUTATION](state, status = true) {
            return (state.isCompletedAll = status);
        },
       
        [SET_SKIP_MUTATION](state, status = true) {
            return (state.isSkip = status);
        },

        [RESET_ONBOARDING_MUTATION](state) {
            state.allowActions = {
                next: true,
                previous: true,
            };

            state.steps = [];

            state.hasOnboarding = false;
            state.isFinished = false;
            state.isCompletedAll = false;
            state.isSkip = false;
            state.isHolding = false;

            return state;
        },

        [HAS_ONBOARDING_MUTATION](state, has = true) {
            return (state.hasOnboarding = has);
        },

        [HOLDING_STEP_MUTATION](state, holding = true) {
            return (state.isHolding = holding);
        },

        [SET_ONBOARDING_PER_PAGE_MUTATION](state, data) {
            return (state.onboardingPerPage.pageName = data);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/vueOnboardingModule.js